"use strict";

exports.__esModule = true;
var _ThresholdPicker = require("./ThresholdPicker");
Object.keys(_ThresholdPicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ThresholdPicker[key]) return;
  exports[key] = _ThresholdPicker[key];
});
var _compareThresholds = require("./compareThresholds");
Object.keys(_compareThresholds).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _compareThresholds[key]) return;
  exports[key] = _compareThresholds[key];
});
var _getThresholdColor = require("./getThresholdColor");
Object.keys(_getThresholdColor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getThresholdColor[key]) return;
  exports[key] = _getThresholdColor[key];
});